module.exports = __webpack_public_path__ + "static/media/JAN-MARCH-2019-SAMATVAM.feec1f50.pdf";